import BranchHoursContainer from './BranchHoursContainer';

export default BranchHoursContainer;
